import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {

  loginForm!: FormGroup;

  isSubmitting = false;

  successMessage = '';

  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private http: HttpClient
  ) { }

  ngOnInit(): void {

    this.initializeForm();

  }

  /* ================= FORM INITIALIZATION ================= */

  initializeForm(): void {

    this.loginForm = this.fb.group({

      name: [
        '',
        [
          Validators.required,
          Validators.minLength(3)
        ]
      ],

      email: [
        '',
        [
          Validators.required,
          Validators.email
        ]
      ],

      mobile: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]{10}$')
        ]
      ],

      message: [
        '',
        [
          Validators.required,
          Validators.minLength(5)
        ]
      ]

    });

  }

  /* ================= GETTERS ================= */

  get formControls() {
    return this.loginForm.controls;
  }

  /* ================= SUBMIT ================= */

  onSubmit(): void {
debugger;
    this.successMessage = '';

    this.errorMessage = '';

    /* FORM VALIDATION */

    if (this.loginForm.invalid) {

      this.loginForm.markAllAsTouched();

      return;
    }

    this.isSubmitting = true;

    /* REQUEST PAYLOAD */

    const payload = {

      name: this.loginForm.value.name,

      email: this.loginForm.value.email,

      mobile: this.loginForm.value.mobile,

      message: this.loginForm.value.message

    };

    /* API CALL */

    this.http.post(
      'https://localhost:44306/api/contactus/Submit',
      payload
    )
    .subscribe({

      next: (response: any) => {

        console.log('API Response:', response);

        this.successMessage =
          'Your message has been submitted successfully.';

        this.isSubmitting = false;

        this.loginForm.reset();

      },

      error: (error) => {

        console.error('API Error:', error);

        this.errorMessage =
          'Something went wrong. Please try again later.';

        this.isSubmitting = false;

      }

    });

  }

}